import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  cta: {
    color: "#ffffff",
    backgroundColor: "#0284c7",
    fontWeight: 600,
    borderRadius: "10px",
    textTransform: "none",
    fontSize: "15px",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.08)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#0369a1",
      boxShadow: "0 4px 12px rgba(2, 132, 199, 0.25)",
      transform: "translateY(-1px)",
    },
  },
}));

export default function RegularButton(props) {
  const classes = useStyles();

  return (
    <Button
      style={{
        width: props.width,
        height: props.height,
        padding: props.padding ?? "12px 24px",
      }}
      className={classes.cta}
      variant="contained"
      href={props.href}
      target={props.target ?? "_blank"}
      rel="noreferrer"
    >
      <span
        style={{
          fontWeight: 600,
          fontSize: props.fontSize ? Number(props.fontSize) : 15,
          color: props.fontColor ?? "#ffffff",
        }}
      >
        {props.text}
      </span>
    </Button>
  );
}
